import https from "@/units/https";
import { apiPath } from '@/units/config';
import QS from "qs";

const request = (config) => {
  if (config.url[0] !== '/') {
    config.url = apiPath + config.url;
  }

  if(config.method == 'POST'){
    return https.post(config.url + '?' + QS.stringify(config.params), config.data, config.custom);
  }

  return https.get(config.url, {params: config.params});
};

export default request;



// WEBPACK FOOTER //
// ./src/units/request.js